export default __webpack_public_path__ + "static/media/NOT RIGHT NOW.056c1cca.mp3";